import React from "react";
import styles from "../../styles/components/pdfModalViewer.module.scss";
import useClickOutside from "../../utility/useClickOutsideHook";
import Icons from "../../public/assets/svg";






const SubmitIdea = (props) => {
  //console.log(props, "pdfviewerprops");
 
 
 
  //const [ Loading, setLoading ] = React.useState(false)
  //const dispatch = useDispatch()

 
  let domNode = useClickOutside(()=>{
    props.setPdfModal(false);
  },React.useRef,React.useEffect)


  

  
  

  return (


   
    <div className={styles.editModalWrapper}>
    
      <div className={styles.modalBox} ref={domNode}>
        <div className={styles.modalHeader}>
          <div className={styles.leftHeader}>
            <Icons name="pdf" className={styles.icon} />
            <p className={styles.content} > {props.pdfTitle}</p>
            <div  className={styles.download} onClick={()=>window.open(props.pdfUrl)}>
            <Icons name="downloadBlue" ></Icons>
            </div>
          </div>
          <p className={styles.close} onClick={()=>props.setPdfModal(false)}>Close</p>
         
        </div>
        <div className={styles.modalBody}>
          <iframe
          //  
            src={
              props.pdfUrl !="" ? `${props.pdfUrl}#toolbar=0&navpanes=0&scrollbar=0&frameBorder=0"` :"http://www.africau.edu/images/default/sample.pdf#toolbar=0&navpanes=0&scrollbar=0"
            }
            type={`application/pdf`}
            width="100%"
            height="450px"
            //  border="none"
          >
            {" "}
          </iframe>
        </div>
    </div>
    
</div>
  
  )}
        

// const mapStateToProps = (state) => {
//   return {
//     submitAnIdeaApiState: state.submitAnIdea
//   }
// }

export default SubmitIdea;

